function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  }
  
  document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
  
    /*if(summary.nextElementSibling.getAttribute('id')) {
      summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }*/
  
    summary.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
  
    if (summary.closest('header-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
  });
  
  const trapFocusHandlers = {};
  
  function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];
  
    removeTrapFocus();
  
    trapFocusHandlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
      )
        return;
  
      document.addEventListener('keydown', trapFocusHandlers.keydown);
    };
  
    trapFocusHandlers.focusout = function() {
      document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };
  
    trapFocusHandlers.keydown = function(event) {
      if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
      // On the last focusable element and tab forward, focus the first element.
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
  
      //  On the first focusable element and tab backward, focus the last element.
      if (
        (event.target === container || event.target === first) &&
        event.shiftKey
      ) {
        event.preventDefault();
        last.focus();
      }
    };
  
    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);
  
    elementToFocus.focus();
  }
  
  // Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
  try {
    document.querySelector(":focus-visible");
  } catch(e) {
    focusVisiblePolyfill();
  }
  
  function focusVisiblePolyfill() {
    const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
    let currentFocusedElement = null;
    let mouseClick = null;
  
    window.addEventListener('keydown', (event) => {
      if(navKeys.includes(event.code.toUpperCase())) {
        mouseClick = false;
      }
    });
  
    window.addEventListener('mousedown', (event) => {
      mouseClick = true;
    });
  
    window.addEventListener('focus', () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
  
      if (mouseClick) return;
  
      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
  
    }, true);
  }
  
  function pauseAllMedia() {
    //console.log('test video');
    document.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }
  
  function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  
    if (elementToFocus) elementToFocus.focus();
  }
  
  function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
  
    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;
  
    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
  }
  
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', { bubbles: true })
  
      this.querySelectorAll('button').forEach(
        (button) => button.addEventListener('click', this.onButtonClick.bind(this))
      );
    }
  
    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;
  
      let qty_tot = 0;
         $('.cart-items .cart-item').each(function(index,item){
          let dataitem = $(this).attr('data');
          if(dataitem){
            // if(var_tit.match("^DEMO") && (dataitem == 'DEMO'|| dataitem == 'demo')){
            if((dataitem == 'DEMO'|| dataitem == 'demo'|| dataitem == 'Demo')){
              // demoFound = true;
              // console.log($(this).find('quantity-input').find('input').val())
              qty_tot = qty_tot + parseInt($(this).find('quantity-input').find('input').val());
            }
          }
        });
      if ((event.target.name === 'plus' && qty_tot < 4) || (event.target.name === 'minus' && qty_tot <= 4)) {
        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
      } else {
        $(".cdelmax").addClass("show-cdel-max");
        $(".cdelmax .max-info").show();
        $(".cdelmax .demo-program").hide();
        $("body").addClass("active-popup");
      }
    }
  }
  
  customElements.define('quantity-input', QuantityInput);
  
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  
  function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }
  
  /*
   * Shopify Common JS
   *
   */
  if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
  }
  
  Shopify.bind = function(fn, scope) {
    return function() {
      return fn.apply(scope, arguments);
    }
  };
  
  Shopify.setSelectorByValue = function(selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
      var option = selector.options[i];
      if (value == option.value || value == option.innerHTML) {
        selector.selectedIndex = i;
        return i;
      }
    }
  };
  
  Shopify.addListener = function(target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
  };
  
  Shopify.postLink = function(path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};
  
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);
  
    for(var key in params) {
      var hiddenField = document.createElement("input");
      hiddenField.setAttribute("type", "hidden");
      hiddenField.setAttribute("name", key);
      hiddenField.setAttribute("value", params[key]);
      form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };
  
  Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
    this.countryEl         = document.getElementById(country_domid);
    this.provinceEl        = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
  
    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));
  
    this.initCountry();
    this.initProvince();
  };
  
  Shopify.CountryProvinceSelector.prototype = {
    initCountry: function() {
      var value = this.countryEl.getAttribute('data-default');
      Shopify.setSelectorByValue(this.countryEl, value);
      this.countryHandler();
    },
  
    initProvince: function() {
      var value = this.provinceEl.getAttribute('data-default');
      if (value && this.provinceEl.options.length > 0) {
        Shopify.setSelectorByValue(this.provinceEl, value);
      }
    },
  
    countryHandler: function(e) {
      var opt       = this.countryEl.options[this.countryEl.selectedIndex];
      var raw       = opt.getAttribute('data-provinces');
      var provinces = JSON.parse(raw);
  
      this.clearOptions(this.provinceEl);
      if (provinces && provinces.length == 0) {
        this.provinceContainer.style.display = 'none';
      } else {
        for (var i = 0; i < provinces.length; i++) {
          var opt = document.createElement('option');
          opt.value = provinces[i][0];
          opt.innerHTML = provinces[i][1];
          this.provinceEl.appendChild(opt);
        }
  
        this.provinceContainer.style.display = "";
      }
    },
  
    clearOptions: function(selector) {
      while (selector.firstChild) {
        selector.removeChild(selector.firstChild);
      }
    },
  
    setOptions: function(selector, values) {
      for (var i = 0, count = values.length; i < values.length; i++) {
        var opt = document.createElement('option');
        opt.value = values[i];
        opt.innerHTML = values[i];
        selector.appendChild(opt);
      }
    }
  };
  
  class MenuDrawer extends HTMLElement {
    constructor() {
      super();
  
      this.mainDetailsToggle = this.querySelector('details');
  
      if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  
      this.addEventListener('keyup', this.onKeyUp.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.bindEvents();
    }
  
    bindEvents() {
      this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }
  
    onKeyUp(event) {
      if(event.code.toUpperCase() !== 'ESCAPE') return;
  
      const openDetailsElement = event.target.closest('details[open]');
      if(!openDetailsElement) return;
  
      openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }
  
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.has-submenu');
      const isOpen = detailsElement.hasAttribute('open');
      const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  
      function addTrapFocus() {
        trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
        summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
      }
  
      if (detailsElement === this.mainDetailsToggle) {
        if(isOpen) event.preventDefault();
        isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
      } else {
        setTimeout(() => {
          detailsElement.classList.add('menu-opening');
          summaryElement.setAttribute('aria-expanded', true);
          parentMenuElement && parentMenuElement.classList.add('submenu-open');
          !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
        }, 100);
      }
    }
  
    openMenuDrawer(summaryElement) {
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
  
    closeMenuDrawer(event, elementToFocus = false) {
      if (event === undefined) return;
  
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
        submenu.classList.remove('submenu-open');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  
    onFocusOut(event) {
      setTimeout(() => {
        if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
      });
    }
  
    onCloseButtonClick(event) {
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
  
    closeSubmenu(detailsElement) {
      const parentMenuElement = detailsElement.closest('.submenu-open');
      parentMenuElement && parentMenuElement.classList.remove('submenu-open');
      detailsElement.classList.remove('menu-opening');
      detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
      removeTrapFocus(detailsElement.querySelector('summary'));
      this.closeAnimation(detailsElement);
    }
  
    closeAnimation(detailsElement) {
      let animationStart;
  
      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }
  
        const elapsedTime = time - animationStart;
  
        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
          if (detailsElement.closest('details[open]')) {
            trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
          }
        }
      }
  
      window.requestAnimationFrame(handleAnimation);
    }
  }
  
  customElements.define('menu-drawer', MenuDrawer);
  
  class HeaderDrawer extends MenuDrawer {
    constructor() {
      super();
    }
  
    openMenuDrawer(summaryElement) {
      this.header = this.header || document.getElementById('shopify-section-header');
      this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
      document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
      this.header.classList.add('menu-open');
  
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });
  
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
  
    closeMenuDrawer(event, elementToFocus) {
      super.closeMenuDrawer(event, elementToFocus);
      this.header.classList.remove('menu-open');
    }
  }
  
  customElements.define('header-drawer', HeaderDrawer);
  
  class ModalDialog extends HTMLElement {
    constructor() {
      super();
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        'click',
        this.hide.bind(this, false)
      );
      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
      if (this.classList.contains('media-modal')) {
        this.addEventListener('pointerup', (event) => {
          if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
        });
      } else {
        this.addEventListener('click', (event) => {
          if (event.target === this) this.hide();
        });
      }
    }
  
    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
    }
  
    show(opener) {
      this.openedBy = opener;
      const popup = this.querySelector('.template-popup');
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');
      if (popup) popup.loadContent();
      trapFocus(this, this.querySelector('[role="dialog"]'));
      window.pauseAllMedia();
    }
  
    hide() {
      document.body.classList.remove('overflow-hidden');
      document.body.dispatchEvent(new CustomEvent('modalClosed'));
      this.removeAttribute('open');
      removeTrapFocus(this.openedBy);
      window.pauseAllMedia();
    }
  }
  customElements.define('modal-dialog', ModalDialog);
  
  class ModalOpener extends HTMLElement {
    constructor() {
      super();
  
      const button = this.querySelector('button');
  
      if (!button) return;
      button.addEventListener('click', () => {
        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (modal) modal.show(button);
      });
    }
  }
  customElements.define('modal-opener', ModalOpener);
  
  class DeferredMedia extends HTMLElement {
    constructor() {
      super();
      const poster = this.querySelector('[id^="Deferred-Poster-"]');
      if (!poster) return;
      poster.addEventListener('click', this.loadContent.bind(this));
    }
  
    loadContent(focus = true) {
      window.pauseAllMedia();
      if (!this.getAttribute('loaded')) {
        const content = document.createElement('div');
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
  
        this.setAttribute('loaded', true);
        const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
        if (focus) deferredElement.focus();
      }
    }
  }
  
  customElements.define('deferred-media', DeferredMedia);
  
  class SliderComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[id^="Slider-"]');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.enableSliderLooping = false;
      this.currentPageElement = this.querySelector('.slider-counter--current');
      this.pageTotalElement = this.querySelector('.slider-counter--total');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
  
      if (!this.slider || !this.nextButton) return;
  
      this.initPages();
      const resizeObserver = new ResizeObserver(entries => this.initPages());
      resizeObserver.observe(this.slider);
  
      this.slider.addEventListener('scroll', this.update.bind(this));
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }
  
    initPages() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
      this.update();
    }
  
    resetPages() {
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.initPages();
    }
  
    update() {
      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
  
      if (this.currentPageElement && this.pageTotalElement) {
        this.currentPageElement.textContent = this.currentPage;
        this.pageTotalElement.textContent = this.totalPages;
      }
  
      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }}));
      }
  
      if (this.enableSliderLooping) return;
  
      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }
  
      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
  
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }
  
    onButtonClick(event) {
      event.preventDefault();
      const step = event.currentTarget.dataset.step || 1;
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
      this.slider.scrollTo({
        left: this.slideScrollPosition
      });
    }
  }
  
  customElements.define('slider-component', SliderComponent);
  
  class SlideshowComponent extends SliderComponent {
    constructor() {
      super();
      this.sliderControlWrapper = this.querySelector('.slider-buttons');
      this.enableSliderLooping = true;
  
      if (!this.sliderControlWrapper) return;
  
      this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
      if (this.sliderItemsToShow.length > 0) this.currentPage = 1;
  
      this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
      this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
      this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
      this.setSlideVisibility();
  
      if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    }
  
    setAutoPlay() {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.autoplaySpeed = this.slider.dataset.speed * 1000;
  
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.addEventListener('mouseover', this.focusInHandling.bind(this));
      this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
      this.addEventListener('focusin', this.focusInHandling.bind(this));
      this.addEventListener('focusout', this.focusOutHandling.bind(this));
  
      this.play();
      this.autoplayButtonIsSetToPlay = true;
    }
  
    onButtonClick(event) {
      super.onButtonClick(event);
      const isFirstSlide = this.currentPage === 1;
      const isLastSlide = this.currentPage === this.sliderItemsToShow.length;
  
      if (!isFirstSlide && !isLastSlide) return;
  
      if (isFirstSlide && event.currentTarget.name === 'previous') {
        this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
      } else if (isLastSlide && event.currentTarget.name === 'next') {
        this.slideScrollPosition = 0;
      }
      this.slider.scrollTo({
        left: this.slideScrollPosition
      });
    }
  
    update() {
      super.update();
      this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
      this.prevButton.removeAttribute('disabled');
  
      if (!this.sliderControlButtons.length) return;
  
      this.sliderControlButtons.forEach(link => {
        link.classList.remove('slider-counter__link--active');
        link.removeAttribute('aria-current');
      });
      this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
      this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }
  
    autoPlayToggle() {
      this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
      this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
      this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
    }
  
    focusOutHandling(event) {
      const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    }
  
    focusInHandling(event) {
      const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    }
  
    play() {
      this.slider.setAttribute('aria-live', 'off');
      clearInterval(this.autoplay);
      this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
    }
  
    pause() {
      this.slider.setAttribute('aria-live', 'polite');
      clearInterval(this.autoplay);
    }
  
    togglePlayButtonState(pauseAutoplay) {
      if (pauseAutoplay) {
        this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
        this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
      } else {
        this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
        this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
      }
    }
  
    autoRotateSlides() {
      const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
      this.slider.scrollTo({
        left: slideScrollPosition
      });
    }
  
    setSlideVisibility() {
      this.sliderItemsToShow.forEach((item, index) => {
        const button = item.querySelector('a');
        if (index === this.currentPage - 1) {
          if (button) button.removeAttribute('tabindex');
          item.setAttribute('aria-hidden', 'false');
          item.removeAttribute('tabindex');
        } else {
          if (button) button.setAttribute('tabindex', '-1');
          item.setAttribute('aria-hidden', 'true');
          item.setAttribute('tabindex', '-1');
        }
      });
    }
  
    linkToSlide(event) {
      event.preventDefault();
      const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
      this.slider.scrollTo({
        left: slideScrollPosition
      });
    }
  }
  
  customElements.define('slideshow-component', SlideshowComponent);
  
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange);
    }
  
    onVariantChange() {
  
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
  
      if (!this.currentVariant) {
         
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
  
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
      }
    }
  
    updateOptions() {
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }
  
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }
  
    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
  
      const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
  
      const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
      if (!modalContent) return;
      const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
      modalContent.prepend(newMediaModal);
    }
  
    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  
    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton || !shareButton.updateUrl) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  
    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  
    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('pickup-availability');
      if (!pickUpAvailability) return;
  
      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }
  
    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;
  
      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }
  
    renderProductInfo() {
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html')
         
          const destination = document.getElementById('price-'+this.dataset.section);
  
          const source = html.getElementById('price-'+this.dataset.section ? this.dataset.originalSection : this.dataset.section);
         var picehtml = $(responseText).find("div#price-"+this.dataset.section).html();
          /*if (source && destination){
            alert("dd");
            destination.innerHTML = source.innerHTML;
          }*/+'---'
  
          if (picehtml){
           $("div#price-"+this.dataset.section).html(picehtml);
          }
  
          const price = document.getElementById('price-'+this.dataset.section);
        //  alert(price);
          if (price) price.classList.remove('visibility-hidden');
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        });
    }
  
    toggleAddButton(disable = true, text, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      if (!addButton) return;
  
      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
      }
  
      if (!modifyClass) return;
    }
  
    setUnavailable() {
      const button = document.getElementById(`product-form-${this.dataset.section}`);
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
      if (price) price.classList.add('visibility-hidden');
    }
  
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  
  customElements.define('variant-selects', VariantSelects);
  
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }
  
    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }
  
  customElements.define('variant-radios', VariantRadios);
  
  
  $(document).ready(function() {
    if ($(window).width() < 768) {
      $("span.link-mtitle").on("click", function() {
        if ($(this).hasClass("active")) {
          $(this).removeClass("active");
          $(this)
          .siblings(".all-menu")
          .slideUp(200);
          $(".minus-ative.active").removeClass("active");
          $(".plus-ative.active").removeClass("active");
        } else {
          $(this)
          $("span.link-mtitle").removeClass("active");
          $(this).addClass("active");
          $(".all-menu").slideUp(200);
          $(this)
          .siblings(".all-menu")
          .slideDown(200);
          $(this).find(".minus-ative").addClass("active");
          $(this).find(".plus-ative").addClass("active");
        }
      });
      };
   
  $('.all-custome-faq-set .data-aac .accodian-info:first-child').addClass('acc-sho');
$('.all-custome-faq-set .data-aac .accodian-info:first-child .custome-faq-all .cus-tt-bot-text .text-faq-support').addClass('show-datas');

  
  });
  
  $( document ).ready(function() {
    $(".close-popup, .popup").on("click", function(){
      $(".popup, .popup-content, .popup-overlay").removeClass("active");
      $('body').removeClass("demoapiadd-pop");
       $('body').removeClass("demoapi_cart-pop");
       $('body').removeClass("social-pop");
      $('body').removeClass("active-pop");
    });
    $(".btn-sign-in").on("click", function(){
      $(".popup, .popup-content, .popup-overlay").addClass("active");
      $('body').addClass("active-pop");
    });
  });
  
  $(".menu-drawer-top svg.icon.icon-close").click(function() {
    $(".close-chisdid").trigger("click");
  });
  
  $( document ).ready(function() { 
     
  
  
    $(".header-pro").on("click", function(){
      
      $(".sdd-inner").find('.list-menu__item.show-list').removeClass("show-list");
      
      var val1 = $(this).closest('li').attr('data');
      $(".sdd-inner").find('.list-menu__item[data_match="'+val1+'"]').addClass("show-list");
      $(".side-draver-desk").addClass("show-drawer");
      $('body').addClass("active-drawer");
    });
  
    $(".close-menudrea svg.icon.icon-close").on("click", function(){
      $(".side-draver-desk.show-drawer").removeClass("show-drawer");
      $('body.active-drawer').removeClass("active-drawer");
  
            $(".side-draver-desk.show-drawer ul.grandchild").css("transform","translateX(-30px)");
             $(".side-draver-desk.show-drawer ul.grandchild").css("transition","all 150ms");
             $(".side-draver-desk.show-drawer ul.grandchild").css("opacity","0");
             $(".side-draver-desk.show-drawer ul.grandchild").css("visibility","hidden");
             $(".side-draver-desk.show-drawer ul.grandchild").css("z-index","0");
  
      
      $('ul.child li.data-all-child.hide-list.list-menu__item.active.child-active.show-list').each(function(index,item){
       
        
           $(this).find("a").removeClass("activehover") ;
          
        $(this).find("ul.grandchild").css("transform","translateX(-30px)");
            $(this).find("ul.grandchild").css("transition","all 150ms");
             $(this).find("ul.grandchild").css("opacity","0");
             $(this).find("ul.grandchild").css("visibility","hidden");
            $(this).find("ul.grandchild").css("z-index","0");
  
       $(this).find(".second_layer_menu").html("");;
       
      })
  
  
          $('ul.grandchild li').each(function(){
                 
            $(this).find("div.newgrandchild.secondchild").css("display","none");
          });
    });
  });
  
  // $(document).ready(function(){
  //   var data_ss = "subcollections";
  //   $('.osc-data-set[data !="'+data_ss+'"]').remove(); 
  // });
  
  if ($(".osc-desk").find(".osc-data").children().hasClass("osc-data-set")) {
    $(".main-cls.osc-desk").show();
  }else{
    $(".main-cls.osc-desk").hide();
  }
  // popup 1  faq//
  $(document).ready(function(){
  /*$(document).on("click",".faq-popup-set",function() {
    $(".faq-popup").css("display","block");
  
    $("body").addClass("active-popup");
  
  
  });*/
  $(document).on("click",".faq-popup-colse",function() {
    $(".faq-popup").css("display","none");
    $("body").removeClass("active-popup");
      $('body').removeClass('opened_faq');
    setTimeout(function(){
   if($('body').hasClass('active-popup')){
      $("body").removeClass("active-popup");
      
    }
    },100);
    
  });
  });
  
  
  // popup 2 readmore desc//
  $(document).on("click",".showmore-btn",function() {
    $(".desc-popup").css("display","block");
    $("body").addClass("active-pop");
  });
  $(document).on("click",".popupclose-desc",function() {
    $(".desc-popup").css("display","none");
    $("body").removeClass("active-pop");
  });
  
  
  // popup 3 //
  $(document).on("click",".sizechart-title",function() {
    $(".popup-chart").css("display","block");
    $("body").addClass("active-popups");
  });
  $(document).on("click",".size-chart-close",function() {
    $(".popup-chart").css("display","none");
    $("body").removeClass("active-popups");
  });
  
  
  $(document).on("click",".pcbt-size-inch",function() {
    $(this).closest(".pcb-top").find(".pcb-info").children(".pcbt-inch").addClass("active-info");
    $(".pcbt-cm.active-info").removeClass("active-info");
    $(this).addClass("active-title");
    $(".pcbt-size-cm.active-title").removeClass("active-title");
  });
  $(document).on("click",".pcbt-size-cm",function() {
    $(this).closest(".pcb-top").find(".pcb-info").children(".pcbt-cm").addClass("active-info");
    $(".pcbt-inch.active-info").removeClass("active-info");
    $(this).addClass("active-title");
    $(".pcbt-size-inch.active-title").removeClass("active-title");
  });
  $(document).on("click",".pcbb-size-inch",function() {
    $(this).closest(".pcb-bot").find(".pcb-info").children(".pcbb-inch").addClass("active-info");
    $(".pcbb-cm.active-info").removeClass("active-info");
    $(this).addClass("active-title");
    $(".pcbb-size-cm.active-title").removeClass("active-title");
  });
  $(document).on("click",".pcbb-size-cm",function() {
    $(this).closest(".pcb-bot").find(".pcb-info").children(".pcbb-cm").addClass("active-info");
    $(".pcbb-inch.active-info").removeClass("active-info");
    $(this).addClass("active-title");
    $(".pcbb-size-inch.active-title").removeClass("active-title");
  });
  
  $(".product-accordion-info").on("click", function(){
  
    if ($(this).hasClass("ditto")) {
      $(this).find("svg.accodian-open-icon").css("display","block");
      $(this).find("svg.accodian-close-icon").css("display","none");
      $(this).find(".accordion-desc").css("display","none").slideUp(200);  
      $(this).removeClass("ditto");
    }else{
      $("svg.accodian-open-icon").css("display","block");
      $("svg.accodian-close-icon").css("display","none");
      $(".accordion-desc").css("display","none").slideUp(200);  
      $(".product-accordion-info.ditto").removeClass("ditto");
  
      $(this).find("svg.accodian-open-icon").css("display","none");
      $(this).find("svg.accodian-close-icon").css("display","block");
      $(this).find(".accordion-desc").css("display","block").slideDown(200);
      $(this).addClass("ditto");
    }
  });
  
  
  
  // $( window ).on( "load", function() {
  //     var pizza = $(".other-swatch").find("input:checked").attr("value");
  //     $(".more-var").closest(".other-swatch-set").find(".other-name").html(pizza);
  // });
  
  
  $(document).on("click",".color-swatch",function() {
   var swarch_data = $(this).attr("data-option");
   $(".color-name").html(swarch_data);
  });
  $(document).on("click",".color-more-var",function() {
   var swa_datas = $(this).attr("data_more");
   $(".color-name").html(swa_datas);
  });
  $(document).on("click",".more-var",function() {
   var swa_data = $(this).attr("data_more");
   $(this).closest(".other-swatch-set").find(".other-name").html(swa_data);
  });
  
  
  
  // $(document).on("click",".more-var",function() {
  //  var swa_data = $(this).attr("data_more");
  //  $(this).closest(".color-set").find(".other-name").html(swa_data);
  // });
  // $(document).on("click",".more-var",function() {
  //   var ddd =  $(this).attr("data_more");
  //   console.log("ddd");
  //   $(".color-name").html(ddd);
  // });
  
  // $(document).on("click",".arrow-var",function() {
  //   $(this).find(".accodian-open-icon").toggleClass("hide-it");
  //   $(this).find(".accodian-close-icon").toggleClass("show-it");
  //   $(this).closest(".other-swatch-set").find(".other-swatch").toggleClass("show-it");
  // });
  $(document).on("click",".other-swatch-bot",function() {
    $(this).find(".accodian-open-icon").toggleClass("hide-it");
    $(this).find(".accodian-close-icon").toggleClass("show-it");
    $(this).closest(".other-swatch-set").find(".other-swatch").toggleClass("show-it");
  });
  
  // $(document).on("click",".compare-all",function() {
  // $( "button.coder-compareder-compare.coder-compare-button" ).trigger( "click" );
  // });
  
  
  $(document).on("click","span.filter-show-text",function() {
    $("span.filter-hide-text").show();
    $(".facets-vertical .facets-wrapper").show();
    $(this).hide();
  });
  
  $(document).on("click","span.filter-hide-text",function() {
    $("span.filter-show-text").show();
    $(".facets-vertical .facets-wrapper").hide();
    $(this).hide();
  });
  
  // $(document).on("click",".osc-data-set",function() {
  // var val1 = $(this).attr("data3");
  // setTimeout(function () {
  //   console.log(val1);
  // }, 50000);
  // });
  
  
  
  $(document).on("click",".mob-product-set",function() {
    $(".mob-product-set-box").addClass("show-pro-pop");
    $(".mobile-product-all-box").slick('refresh');
  });
  $(document).on("click",".popupclose-product",function() {
    $(".mob-product-set-box.show-pro-pop").removeClass("show-pro-pop");
  });
  
  $(document).on("click",".btn-play",function() {
    $(".video-set-mv").show();
    $(".benner-of-videp").hide();
    $(this).hide();
  });
  $(document).on("click",".close-video",function() {
    $(".video-set-mv").hide();
    $(".benner-of-videp").show();
    $(".btn-play").show();
  });
  
  
  $(document).on("click",".product__media-item",function() {
    $(".desk-pro-slid-set").show();
  });
  $(document).on("click",".popup-closes.pro-fenc-popup-colse",function() {
    $(".desk-pro-slid-set").hide();
  });
  
  // accordian page 


  $(document).on("click",".accodian-info",function() {
    $(".text-faq-support.show-datas").removeClass("show-datas");
    $("svg.accodian-close-icon").hide();
    $("svg.accodian-open-icon").show();
    $(".accodian-info.acc-sho").removeClass("acc-sho"); 
    $(this).find(".text-faq-support").addClass("show-datas");
    $(this).find("svg.accodian-close-icon").show();
    $(this).find("svg.accodian-open-icon").hide();
    $(this).addClass("acc-sho");
  });
  $(document).on("click",".accodian-info.acc-sho",function() {
    if ($(this).hasClass("acc-sho")) {
      $(".text-faq-support.show-datas").removeClass("show-datas");
      $("svg.accodian-close-icon").hide();
      $("svg.accodian-open-icon").show();
      $(".accodian-info.acc-sho").removeClass("acc-sho");    
    }
  });
  // end of accordian page 
  
  
  $(document).on("click",".more-grip",function() {
    var ddd =  $(this).attr("dataal");
    $(".cus-add-grip-price").html(ddd);
  });
  
  $(document).on("click",".more-grip",function() {
    $(this).closest(".gripset-all").find(".more-grip.hideicons").toggleClass("shot");
  
  });
  
  // quiz 1
  $(document).on("click",".demo-pro-quiz-btn a",function() {
   //  $("body").css("opacity","0.5");
     $('.loader-sec').show();
    setTimeout(function() {
  
        var deviceWidth = $(window).width();
     if(deviceWidth >=  767){
      $('.quiz_step').each(function(){
        
        var totalopt = 0;
          $(this).find('.pop-quiz-mid-data').each(function(){
            totalopt = parseInt(totalopt) + 1 ;
          });
        //alert(totalopt);
        if(totalopt != '' && totalopt != 0){
          if(totalopt >= 4){
            totalopt = 4 ;
          }
  
          $(this).attr("totalopt",totalopt);
          var optwidth = 100 / parseInt(totalopt);
          var newmaxwidth = optwidth+"%";
          var newwidth = "0 0 "+optwidth+"%";
          $(this).find('.pop-quiz-mid-data').css("flex",newwidth);
          $(this).find('.pop-quiz-mid-data').css("max-width",newmaxwidth);
          $(this).find(".btn-inf").addClass("disable_continue");
        }
       
  
      });
      
     }
      
  $('.loader-sec').hide();
      // $("body").css("opacity","1");
    $(".quiz-main.quiz-questions").css("display","block");
    $("body").addClass("active-pop");
  
        },2000);
  
     
  });
  
  
  $(document).on("click",".quiz-close",function() {
    $(".quiz-main.quiz-questions").css("display","none");
    $("body").removeClass("active-pop");
  });
  $(document).on("click",".pqmd-btn",function() {
    //alert("tes3t");
    $(this).closest(".pop-quiz-mid-set").find(".pqmd-btn.active").removeClass("active");
    $(this).addClass("active");
    $(this).closest(".popup-quiz-set").find(".pop-quiz-bot .btn-inf a.fs16").addClass("active");
    $(this).closest(".popup-quiz-set").find(".pop-quiz-bot .btn-inf a.fs16").css("background","#212120");
    $('.pquizb-bothbtn .btn-inf a').removeClass('crsr-not-allow');
     $(this).closest(".popup-quiz-set").find(".btn-inf").removeClass("disable_continue");
  });
  // quiz 2
  $(document).on("click",".pquizb-btnset-1",function() {
    $(".popup-quiz-2").css("display","block");
    $(".popup-quiz").css("display","none");
  });
  
  $(document).on("click",".bk-2",function() {
    $(".popup-quiz").css("display","block");
    $(".popup-quiz-2").css("display","none");
  });
  
  // quiz 3
  $(document).on("click",".pquizb-btnset-2-1",function() {
    $(".popup-quiz-3").css("display","block");
    $(".popup-quiz-2").css("display","none");
  });
  $(document).on("click",".bk-3",function() {
    $(".popup-quiz-2").css("display","block");
    $(".popup-quiz-3").css("display","none");
  });
  
  // quiz 4
  $(document).on("click",".pquizb-btnset-3-1",function() {
    $(".popup-quiz-4").css("display","block");
    $(".popup-quiz-3").css("display","none");
  });
  $(document).on("click",".bk-4",function() {
    $(".popup-quiz-3").css("display","block");
    $(".popup-quiz-4").css("display","none");
  });
  
  // quiz 5
  $(document).on("click",".pquizb-btnset-4-1",function() {
    $(".popup-quiz-5").css("display","block");
    $(".popup-quiz-4").css("display","none");
  });
  $(document).on("click",".bk-5",function() {
    $(".popup-quiz-4").css("display","block");
    $(".popup-quiz-5").css("display","none");
  });
  
  // quiz 6
  $(document).on("click",".pquizb-btnset-5-1",function() {
    $(".popup-quiz-6").css("display","block");
    $(".popup-quiz-5").css("display","none");
  });
  $(document).on("click",".bk-6",function() {
    $(".popup-quiz-5").css("display","block");
    $(".popup-quiz-6").css("display","none");
  });
  
  
  $(document).on("click",".btn-inf",function() {
    var data_info = $(this).closest(".popup-quiz-set").find(".pqmd-btn.active").attr("data");
  });
  
  
  $(document).on("click",".demo-pro-faq-btn a",function() {
    $(".demo-faq-popup").css("display","block");
    
     setTimeout(function () {
        $("body").addClass("active-pop");
        $("body").addClass("add_faq_pop");
        }, 500);
  
  });
  $(document).on("click",".demo-faq-colse",function() {
  
    $(".demo-faq-popup").css("display","none");
    $("body").removeClass("active-pop");
     $('body').removeClass('add_faq_pop');
  
  });
  
  
  $(document).on("click","div#multi_slide .btn-play-vid",function() {
   //alert("multi slider");
     //$('.loader-sec').show();
    $(this).closest(".product-meta").find(".pop-gel-vid").css("display","block");
    $(this).closest(".product-meta").find(".pop-gel-vid .pop-gel-set").css("display","block");
    var its = $(this).closest(".video-sec-set").attr("itimg");
    $(this).closest(".product-meta").find('.pop-gel-vid .video-sec-set[itvid ="'+its+'"]').css("display","block");
    $("body").addClass("active-pop-pop");
  });
  $(document).on("click",".close-vid",function() {
    $(this).closest(".product-meta").find(".pop-gel-vid").hide(); 
    $("body").removeClass("active-pop-pop");
    $(this).closest(".pop-gel-vid").find('.video-sec-set').css("display","none");
  });
  
  if ($(window).width() > 768) {
    $(".video-sec-set").mousemove(function(event){
      let fromleft = event.offsetX;
      let fromtop = event.offsetY;
      let newposX = fromleft - 60;
      let newposY = fromtop - 60; 
      // console.log(fromleft+"left");
      // console.log(fromtop+"top");
       if ($(window).width() > 991) {
      $(this).find(".btn-play-vid").css("left",+ newposX + "px");  
      $(this).find(".btn-play-vid").css("top",+ newposY + "px"); 
        }
      $(this).find(".btn-play-vid").css("opacity","1"); 
    });
  
    $(".video-sec-set").mouseleave(function(event){
      if ($(window).width() > 991) {
      $(this).find(".btn-play-vid").css("opacity","0");  
      $(this).find(".btn-play-vid").css("top","42%");  
      $(this).find(".btn-play-vid").css("left","42%");    
      if($(this).closest("div#single_swiper").length){
        //alert("test");
        $(this).find(".btn-play-vid").css("top","42%");  
        $(this).find(".btn-play-vid").css("left","47%");
      }
      
      }
  
    });
  
    $(".img-video-set").mousemove(function(event){
   
      let fromleft = event.offsetX;
      let fromtop = event.offsetY;
      let newposX = fromleft - 60;
      let newposY = fromtop - 60; 
      // console.log(fromleft+"left");
      // console.log(fromtop+"top");
       if ($(window).width() > 991) {
      $(this).find(".btn-play-vid").css("left",+ newposX + "px");  
      $(this).find(".btn-play-vid").css("top",+ newposY + "px"); 
        }
        
       
      $(this).find(".btn-play-vid").css("opacity","1"); 
    });
  
    $(".img-video-set").mouseleave(function(event){
     // alert("rtse");
     
      if ($(window).width() > 991) {
         $(this).find(".btn-play-vid").css("top","42%");  
      $(this).find(".btn-play-vid").css("left","42%");  
       if($(this).closest("div#single_swiper").length){
        $(this).find(".btn-play-vid").css("top","42%");  
        $(this).find(".btn-play-vid").css("left","47%");
      }
      
      $(this).find(".btn-play-vid").css("opacity","0");    
      }
    });
  
  
  $(document).click(function(e){
  
  
        //if($(e.target).parents('.faq-popup').length == 0 && $(e.target).parents('.faq-popup').length == 0){
          if ( $(e.target).parents('div#multi_slide .video-sec-set').length != 0) {   
            //alert("notopened");
             $(e.target).parents('div#multi_slide .video-sec-set').closest(".product-meta").find(".pop-gel-vid").css("display","block");
            $(e.target).parents('div#multi_slide .video-sec-set').closest(".product-meta").find(".pop-gel-vid .pop-gel-set").css("display","block");
            var its = $(e.target).parents('div#multi_slide .video-sec-set').closest(".video-sec-set").attr("itimg");
            $(e.target).parents('div#multi_slide .video-sec-set').closest(".product-meta").find('.pop-gel-vid .video-sec-set[itvid ="'+its+'"]').css("display","block");
            $("body").addClass("active-pop-pop");
  
          }else if ($(e.target).parents('div#multi_slide .video-sec-set').length == 0) {   
  
            if (e.target.id != '.video-sec-video.pop-gel-set' && $(e.target).parents('.video-sec-video.pop-gel-set').length == 0) {   
              
            
              $(".pop-gel-vid").css("display","none");
            $(".pop-gel-vid .pop-gel-set").css("display","none");
           // var its = $(e.target).parents('div#multi_slide .video-sec-set').attr("itimg");
            //alert(its);
            $('.pop-gel-vid .video-sec-set').css("display","none");
            $("body").removeClass("active-pop-pop");
              
            }
  
  
           
  
           //  alert("opened");
         
          }
  
        
  });
  
  /*$(document).on("click","div#multi_slide .video-sec-img",function(event) {
  
    event.preventDefault();
  
    $(this).closest(".product-meta").find(".pop-gel-vid").css("display","block");
    $(this).closest(".product-meta").find(".pop-gel-vid .pop-gel-set").css("display","block");
    var its = $(this).closest(".video-sec-set").attr("itimg");
    $(this).closest(".product-meta").find('.pop-gel-vid .video-sec-set[itvid ="'+its+'"]').css("display","block");
    $("body").addClass("active-pop-pop");
  
   
  });*/
  
  
  };
  
  /*if ($(".product-meta").find(".video-sec-gel").children().hasClass("video-sec-set")) {
    $(".product-meta").show();
  }else{
    $(".product-meta").hide();
  }*/
  
  $(document).on("click",".icon-checkmark",function() {
    $(".facets-wrapper .facets-container").addClass("overlay-fil");
      setTimeout(function() {
          $(".facets-wrapper .facets-container.overlay-fil").removeClass("overlay-fil");
      }, 5000);
   var dish = $(this).closest(".facets__item").find("input").attr("value");
     setTimeout(function () {
       $(".active-facets-desktop").find('span[dadd ="'+dish+'"]').trigger("click");
       
      }, 2000);
  });
  
  
  $(document).on("click",".facet-checkbox input",function() {
    $(".facets-wrapper .facets-container").addClass("overlay-fil");
      setTimeout(function() {
          $(".facets-wrapper .facets-container.overlay-fil").removeClass("overlay-fil");
      }, 5000);
  });
  // $(".facets-container").on('DOMSubtreeModified', function(){
  //   ComparederReInit();
  // });
  
  $(document).on("click",".ced-demo-close .dsdsds",function() {
    $(".cdel.show-cdel").removeClass("show-cdel");
    if($("body").hasClass("demoapiadd-pop")){
         $('body').removeClass('demoapiadd-pop');
    }
    if($("body").hasClass("demoapi_cart-pop")){
         $('body').removeClass('demoapi_cart-pop');
    }
    
    $("body").removeClass("active-popup");
  });
  
  $(document).on("click",".ced-demo-close-max .dsdsds-max",function() {
    $(".cdelmax.show-cdel-max").removeClass("show-cdel-max");
    $("body").removeClass("active-popup");
  });
  
  $(document).on("click",".ok-btn",function() {
    $(".cdelmax.show-cdel-max").removeClass("show-cdel-max");
    $("body").removeClass("active-popup");
  });
  
  $(document).on("click",".facet-checkbox span",function() {
    if ($(this).closest(".facet-checkbox").find("input").is(':checked')) {
      $(this).closest(".facet-checkbox").find(".icon-checkmark").trigger("click");
    }
  });
  
  
  $(document).on("click",".drawer-cart",function() {
      $(".menu-drawer-top").find(".icon-close").trigger("click");
      $('.cart-drawer').addClass("cart-dra-opp");
      $("body").addClass("active-popup");
  });
  
  
  $(document).on("click",".draver-search",function() {
      $(".menu-drawer-top").find(".icon-close").trigger("click");
      $(".had").trigger("click");
  });
  
  $( document ).ready(function() {
    $("svg.icon.icon-hamburger").on("click", function(){
      $('body').addClass("active-pop");
    });
    $(".menu-drawer-top .icon-close").on("click", function(){
      $('body').removeClass("active-pop");
    });
  });
  
  $(document).on("click",".andl-info",function() {
      $(".andl-info-link.active").removeClass("active");
      $(".andr-info").removeClass("active");
      $(this).find(".andl-info-link").addClass("active");
      var clos = $(this).find(".andl-info-link").attr("cos");
      $(this).closest(".acc-new-des-set").find(".acc-new-des-r").children('.andr-info[cos="'+clos+'"]').addClass("active");
  });
  
  // $( window ).on( "load", function() {
  //     var pizza = $(".optn-set").find("input:checked").attr("value");
  //     $(".optn-set").closest(".product-form__input").find(".all-sel").html(pizza);
  // });
  
  if($('.mobile-product-all').length){
  
  
  $('.mobile-product-all').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    asNavFor: '.mobile-product-all-box',
    fade: true
  });
  }
  if($('.mobile-product-all-box').length){
  
  $('.mobile-product-all-box').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    asNavFor: '.mobile-product-all',
    dots: false
  });
  }
  
  $(document).on("click",".fblin",function(e) {
      e.preventDefault();
      $(".sic-set.fb-set").css("display","block");
      $('body').addClass("active-pop");
  });
  
  
  $(document).on("click",".inslin",function(e) {
      e.preventDefault();
      $(".sic-set.insta-set").css("display","block");
      $('body').addClass("active-pop");
  });
  
  
  $(document).on("click",".yulin",function(e) {
      e.preventDefault();
      $(".sic-set.youtube-set").css("display","block");
      $('body').addClass("active-pop");
  });
  
  
  $(document).on("click",".ticlin",function(e) {
      e.preventDefault();
      $(".sic-set.tictok-set").css("display","block");
      $('body').addClass("active-pop");
  });
  
  
  
  
  $(document).on("click",".list-social__link",function(e) {
     $('.loader-sec.hidden-').css("display","block");
     // e.preventDefault();
     setTimeout(function () {
        $('body').addClass('social-pop');
      $(".social-icon-popup").addClass("open-pops");
      $('.loader-sec.hidden-').css("display","none");
        $('body').addClass('active-pop');
       },1000);
      
  
  });
  
  $(document).on("click",".tandt",function() {
      $(".sic-set.fb-set").css("display","none");
      $('body').removeClass("social-pop");
      $('body').removeClass("active-pop");
      $(".sic-set.insta-set").css("display","none");
      $(".sic-set.youtube-set").css("display","none");
      $(".sic-set.tictok-set").css("display","none");
      $(".social-icon-popup").removeClass("open-pops");
  });
  
  
  $(document).ready(function() {
  
    var kalu1 = $(".fb-als").children().length;
    var kalu2 = $(".ins-als").children().length;
    var kalu3 = $(".tt-als").children().length;
    var kalu4 = $(".yt-als").children().length;
  
    if(kalu1 == 4){
      $(".fb-als").addClass("nor-show");
    }else if(kalu1 == 3){
      $(".fb-als").addClass("tr-show");
    }else if(kalu1 == 2){
      $(".fb-als").addClass("tw-show");
    }else{
      $(".fb-als").addClass("tw-show");
    }
  
      if(kalu2 == 4){
      $(".ins-als").addClass("nor-show");
    }else if(kalu2 == 3){
      $(".ins-als").addClass("tr-show");
    }else if(kalu2 == 2){
      $(".ins-als").addClass("tw-show");
    }else{
      $(".ins-als").addClass("tw-show");
    }
  
    if(kalu3 == 4){
      $(".tt-als").addClass("nor-show");
    }else if(kalu3 == 3){
      $(".tt-als").addClass("tr-show");
    }else if(kalu3 == 2){
      $(".tt-als").addClass("tw-show");
    }else{
      $(".tt-als").addClass("tw-show");
    }
  
    if(kalu4 == 4){
      $(".yt-als").addClass("nor-show");
    }else if(kalu4 == 3){
      $(".yt-als").addClass("tr-show");
    }else if(kalu4 == 2){
      $(".yt-als").addClass("tw-show");
    }else{
      $(".yt-als").addClass("tw-show");
    }
  });
  
  
  // $( document ).ready(function() {
  //     var val = $(".cart-drawer-set").closest(".cart-drawer").find(".cart-drawer-min").children(".cdmset").length;
  //     if ( val == 0 ) {
  //     $(".cart-drawer-set").addClass("hide-conts");
  //     }else{
  //     $(".cart-drawer-set.hide-conts").removeClass("hide-conts");
  //     }
  // });
  /*-- Popup quiz js --*/
  $(document).ready(function(){
    var quizOption1=0,quizOption2=0,quizOption3=0,quizOption4=0,quizOption5=0;
    var quizOptionArr = [];
    var quizOptionField = {};
    var shopifyAdminSlug = Shopify.shop;
    //var baseApiUrl = 'https://'+shopifyAdminSlug+'/admin/api/2022-07/';
  
    //var baseApiUrl = 'https://gearbox.websitetestingbox.com/api/';
    var baseApiUrl = 'https://phplaravel-943854-3283368.cloudwaysapps.com/api';
    //step1
    $('body').on('click', '.pquizb-btnset-1', function(){
        var selectedOptionVal1 = '';
        $('.demo-pro-quiz-info .popup-quiz .pop-quiz-mid .pop-quiz-mid-set .pop-quiz-mid-data').each(function(optionIndex, optionObj){
            if($(optionObj).find('.pqmd-btn').hasClass('active')){
                selectedOptionVal1 = $(optionObj).find('.pqmd-btn').attr("data");
                quizOption1 = 1;
            }
        });
        if(quizOption1 == 0){
            $('.pquizb-btnset-1 a').addClass('crsr-not-allow');
            /*if($('.demo-pro-quiz-info .popup-quiz .pop-quiz-mid').find('.warn-msg').length==0){
                $('.demo-pro-quiz-info .popup-quiz .pop-quiz-mid').append('<p class="warn-msg">Please selct any one option.');
            }*/
            return false;
        } else{
          // $('.pquizb-btnset-1 a').addClass('active');
            quizOptionField.id = 1;
            quizOptionField.name = selectedOptionVal1;
            quizOptionArr.push({...quizOptionField});
        }
        //console.log('quizOptionArr',quizOptionArr);
        quizOption1=0;
    });
    //step2
    $('body').on('click', '.pquizb-btnset-2-1', function(){
        var selectedOptionVal2 = '';
        $('.demo-pro-quiz-info .popup-quiz-2 .pop-quiz-mid .pop-quiz-mid-set .pop-quiz-mid-data').each(function(optionIndex, optionObj){
            if($(optionObj).find('.pqmd-btn').hasClass('active')){
                selectedOptionVal2 = $(optionObj).find('.pqmd-btn').attr("data");
                quizOption2 = 1;
            }
        });
        if(quizOption2 == 0){
            $('.pquizb-btnset-2-1 a').addClass('crsr-not-allow');
            /*if($('.demo-pro-quiz-info .popup-quiz-2 .pop-quiz-mid').find('.warn-msg').length==0){
                $('.demo-pro-quiz-info .popup-quiz-2 .pop-quiz-mid').append('<p class="warn-msg">Please selct any one option.');
            }*/
            return false;
        } else{
          // $('.pquizb-btnset-2-1 a').addClass('active');
            quizOptionField.id = 2;
            quizOptionField.name = selectedOptionVal2;
            quizOptionArr.push({...quizOptionField});
        }
        quizOption2=0;
    });
    //step3
    $('body').on('click', '.pquizb-btnset-3-1', function(){
        var selectedOptionVal3 = '';
        $('.demo-pro-quiz-info .popup-quiz-3 .pop-quiz-mid .pop-quiz-mid-set .pop-quiz-mid-data').each(function(optionIndex, optionObj){
            if($(optionObj).find('.pqmd-btn').hasClass('active')){
                selectedOptionVal3 = $(optionObj).find('.pqmd-btn').attr("data");
                quizOption3 = 1;
            }
        });
        if(quizOption3 == 0){
            $('.pquizb-btnset-3-1 a').addClass('crsr-not-allow');
            /*if($('.demo-pro-quiz-info .popup-quiz-3 .pop-quiz-mid').find('.warn-msg').length==0){
                $('.demo-pro-quiz-info .popup-quiz-3 .pop-quiz-mid').append('<p class="warn-msg">Please selct any one option.');
            }*/
            return false;
        } else{
          // $('.pquizb-btnset-3-1 a').addClass('active');
            quizOptionField.id = 3;
            quizOptionField.name = selectedOptionVal3;
            quizOptionArr.push({...quizOptionField});
        }
        quizOption3=0;
    });
    //step4
    $('body').on('click', '.pquizb-btnset-4-1', function(){
        var selectedOptionVal4 = '';
        $('.demo-pro-quiz-info .popup-quiz-4 .pop-quiz-mid .pop-quiz-mid-set .pop-quiz-mid-data').each(function(optionIndex, optionObj){
            if($(optionObj).find('.pqmd-btn').hasClass('active')){
                selectedOptionVal4 = $(optionObj).find('.pqmd-btn').attr("data");
                quizOption4 = 1;
            }
        });
        if(quizOption4 == 0){
            $('.pquizb-btnset-4-1 a').addClass('crsr-not-allow');
            /*if($('.demo-pro-quiz-info .popup-quiz-4 .pop-quiz-mid').find('.warn-msg').length==0){
                $('.demo-pro-quiz-info .popup-quiz-4 .pop-quiz-mid').append('<p class="warn-msg">Please selct any one option.');
            }*/
            return false;
        } else{
          // $('.pquizb-btnset-4-1 a').addClass('active');
            quizOptionField.id = 4;
            quizOptionField.name = selectedOptionVal4;
            quizOptionArr.push({...quizOptionField});
        }
        quizOption4=0;
    });
    //step5
    $('body').on('click', '.pquizb-btnset-5-1', function(){
        var selectedOptionVal5 = '';
        $('.demo-pro-quiz-info .popup-quiz-5 .pop-quiz-mid .pop-quiz-mid-set .pop-quiz-mid-data').each(function(optionIndex, optionObj){
            if($(optionObj).find('.pqmd-btn').hasClass('active')){
                selectedOptionVal5 = $(optionObj).find('.pqmd-btn').attr("data");
                quizOption5 = 1;
            }
        });
        if(quizOption5 == 0){
            $('.pquizb-btnset-5-1 a').addClass('crsr-not-allow');
            /*if($('.demo-pro-quiz-info .popup-quiz-5 .pop-quiz-mid').find('.warn-msg').length==0){
                $('.demo-pro-quiz-info .popup-quiz-5 .pop-quiz-mid').append('<p class="warn-msg">Please selct any one option.');
            }*/
            return false;
        } else{
          // $('.pquizb-btnset-5-1 a').addClass('active');
            quizOptionField.id = 5;
            quizOptionField.name = selectedOptionVal5;
            quizOptionArr.push({...quizOptionField});
        }
        quizOption5=0;
       // console.log('quizOptionArr',quizOptionArr);
    });
    //step6
  
  
  $('body').on('change', '.needsclick.kl-private-reset-css-Xuajs1 form.needsclick.klaviyo-form.klaviyo-form-version-cid_4.kl-private-reset-css-Xuajs1 input', function(){
      if($(this).val() != ''){
           $(".needsclick.kl-private-reset-css-Xuajs1 form.needsclick.klaviyo-form.klaviyo-form-version-cid_4.kl-private-reset-css-Xuajs1 .needsclick.kl-private-reset-css-Xuajs1 button").css("background","black");
        $(".needsclick.kl-private-reset-css-Xuajs1 form.needsclick.klaviyo-form.klaviyo-form-version-cid_4.kl-private-reset-css-Xuajs1 .needsclick.kl-private-reset-css-Xuajs1 button").addClass("addblack");
          $(".needsclick.go3295373554.kl-private-reset-css-Xuajs1").css("display","none");
      }else{
           $(".needsclick.kl-private-reset-css-Xuajs1 form.needsclick.klaviyo-form.klaviyo-form-version-cid_4.kl-private-reset-css-Xuajs1 .needsclick.kl-private-reset-css-Xuajs1 button").css("background","#666666");
        $(".needsclick.kl-private-reset-css-Xuajs1 form.needsclick.klaviyo-form.klaviyo-form-version-cid_4.kl-private-reset-css-Xuajs1 .needsclick.kl-private-reset-css-Xuajs1 button").removeClass("addblack");
   
      }
     
    });
    
    $('body').on('submit', '.needsclick.kl-private-reset-css-Xuajs1 form.needsclick.klaviyo-form.klaviyo-form-version-cid_4.kl-private-reset-css-Xuajs1', function(){
      $(".laststep_title").css("display","none");
    });
  
    $('body').on('click', '.demo-prod-api-call', function(){
          if($(this).hasClass("btn_contss")){
                var emaildata = $(this).closest(".popup-quiz-set").find("form.needsclick.klaviyo-form.klaviyo-form-version-cid_4.kl-private-reset-css-Xuajs1 input").val();
           //alert(emaildata);
           if(emaildata == ''){
                  //$(this).addClass("disable_continue");
                  $('form.needsclick.klaviyo-form.klaviyo-form-version-cid_4.kl-private-reset-css-Xuajs1 input').click();
                  return false;
           }
          }
        
  
      var prodIDTagArr = [];
      var productField = {};
        $.ajax({
            type: "GET",
            /*url: baseApiUrl+"products.json?status=active&fields=id,title,body_html,handle,image,tags",
            'headers': {
                'X-Shopify-Access-Token': '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',
                'Content-Type': 'application/json',
            },*/
            url: baseApiUrl+"/product-list",
            beforeSend: function() {
              $(".loader-section").css('display','block');
              //$("body").css('overflow-y','hidden');
              $("body").addClass("active-popup");
            },
            'crossDomain': true,
            cache: false,
            success: function(data){
                //$("#resultarea").text(data);
                var productList = data.data;
                //console.log('data ',productList);
                $.each(productList, function(index, productListVal){
                    if(productListVal.tags){
                        var productTag = productListVal.tags.toLocaleLowerCase();
                        /*console.log( index + ": tags :------------------------------------ " + productTag,' ProdId ',productListVal.id);*/
                        for (let i = 0; i < quizOptionArr.length; i++) {
                            var quizOptionLower = quizOptionArr[i].name.toLocaleLowerCase();
                            if(productTag.includes(quizOptionLower)){
                                /*console.log('-*-*-*-*-*-*-*-*-*- matched -*-*-*-*-*-*-*-*-*-');*/
                                productField.prod_id = productListVal.id;
                                productField.count = 1;
                                productField.tag = quizOptionLower;
                                productField.tags = productListVal.tags;
                                productField.title = productListVal.title;
                                productField.body_html = productListVal.body_html;
                                productField.img = '';
                                if(productListVal.image.src){
                                  productField.img = productListVal.image.src;
                                }
                                productField.handle = productListVal.handle;
                                //productField.body_html = productListVal.body_html;
                                upsert(prodIDTagArr, {prod_id: productListVal.id, count: productField.count, tag: quizOptionLower, title: productField.title,tags:productField.tags, img: productField.img, handle: productField.handle});
                                //productField.count = 1;
                                //prodIDTagArr.push({...productField});
                            }
                            /*console.log('loop index: '+quizOptionArr[i].id+' , name '+quizOptionLower,' prodIDTagArr ',prodIDTagArr);*/
                            if(productTag.includes(quizOptionLower)){
                              //console.log('-*-*-*-*-*-*-*-*-*- matched -*-*-*-*-*-*-*-*-*-');
                            }
                        }
                    }
                });
                //console.log('At last');
                //console.log('quizOptionArr ',quizOptionArr);
                prodIDTagArr.sort(function(a, b) { 
                  return b.count - a.count  ||  b.prod_id - a.prod_id;
                });
                prodIDTagArr.sort(function(a, b) {
                  return (b.tag.match(/,/g) || []).length  - (a.tag.match(/,/g) || []).length;
                });
                var excludeProdId = [];
                for(let iyy=0; iyy<prodIDTagArr.length;iyy++){
                    let tempTitle = prodIDTagArr[iyy].title.toLowerCase();
                    if(!tempTitle.includes('demo')){
                        excludeProdId.push(prodIDTagArr[iyy].prod_id);
                    }
                }
                if((excludeProdId) && (excludeProdId.length>0)){
                    for(let izz=0; izz<excludeProdId.length; izz++){
                        for(let iyi=0; iyi<prodIDTagArr.length;iyi++){
                            if(prodIDTagArr[iyi].prod_id === excludeProdId[izz]){
                                prodIDTagArr.splice(iyi, 1);
                            }
                        }
                    }
                }
                //console.log('prodIDTagArr',prodIDTagArr);
                var optionTagArr = {};
                var optionTagStr = '';
                $.each(quizOptionArr, function(index, quizOptionArrVal){
                    if(quizOptionArrVal.name){
                        var quizOptionNm = quizOptionArrVal.name.toLocaleLowerCase();
                        optionTagArr[quizOptionNm] = new Array();
                        if(optionTagStr){
                          optionTagStr = optionTagStr+', '+quizOptionNm;
                        } else {
                          optionTagStr = quizOptionNm;
                        }
                        for (let i = 0; i < prodIDTagArr.length; i++) {
                            if(prodIDTagArr[i].tag.toLocaleLowerCase().includes(quizOptionNm)){
                            //if(quizOptionNm == prodIDTagArr[i].tag.toLocaleLowerCase()){
                                optionTagArr[quizOptionNm].push(prodIDTagArr[i].prod_id);
                            }
                        }
                    }
                });
               // console.log('obj ',optionTagArr);     
                //$("body").css('overflow-y','unset');
                $("body").removeClass("active-popup");
                $(".loader-section").css('display','none');
                function upsert(array, element) {
                  const i = array.findIndex(_element => _element.prod_id === element.prod_id);
                  if (i > -1){
                    element.count = element.count+1;
                    if(!array[i].tag.toLocaleLowerCase().includes( element.tag)){
                      element.tag = array[i].tag+', '+ element.tag;
                    }
                    array[i] = element; // (2)
                  } else{
                    array.push(element);
                  }
                }
                /*-- Display product based on quiz --*/
                var quizResult = '';
                var prodlist = '';
                var recomlist = '';
                var newquiztitle = '';
                 var newquizdesc = '';
                 var newcartquiztitle = '';
                var prodMetaId = [];
  
                let selectedVariantId = $(".quiz-main.product-variant select#variant-dropdown option").filter(":selected").data('var-id');
        var qty_tot = 0;
         $('.cart-drawer-min .cdmset').each(function(index,item){
          let dataitem = $(this).attr('data');
          if(dataitem){
            // if(var_tit.match("^DEMO") && (dataitem == 'DEMO'|| dataitem == 'demo')){
            if((dataitem == 'DEMO'|| dataitem == 'demo'|| dataitem == 'Demo')){
              // demoFound = true;
              // console.log($(this).find('quantity-input').find('input').val())
              qty_tot = qty_tot + parseInt($(this).find('quantity-input').find('input').val());
            }
          }
        });
  
         var newcount = 4 - parseInt(qty_tot) ;
  
                if(prodIDTagArr){
                  if(newcount == 0){
                    newquiztitle +=`<div class="facets facets-vertical-sort page-width quiz-product-main-title">
                      <h2>Nice! Let's wrap this up.</h2>
                      <div style="
      display: flex;
      margin-bottom: 35px;
      text-align: center;
      display: inline-grid;
  " class="view_Cart_demoapi"><a href="/cart" style="
      width: 198px;
      height: 52px;
      /* left: 621px; */
      /* top: 266px; */
  
  /* Black */
      background: #212120;
  /* Grey */
      border: 0.5px solid #666666;
      padding-top: 15px;
      display: inline;
      color: white;
      text-decoration: none;
  ">View Cart</a></div>
                  </div>`;
                }else{
                  newquiztitle +=`<div class="facets facets-vertical-sort page-width quiz-product-main-title">
                      <h2>Select <span id="quiz-product-count">${newcount}</span> paddles to try during the Demo Program.</h2>
                  </div>`;
                }
                  
                  newcartquiztitle +=`<div class="facets facets-vertical-sort page-width quiz-product-main-title">
                      <h2>Nice! Let's wrap this up.</h2>
                      <div style="
      display: flex;
      margin-bottom: 35px;
      text-align: center;
      display: inline-grid;
  " class="view_Cart_demoapi"><a href="/cart" style="
      width: 198px;
      height: 52px;
      /* left: 621px; */
      /* top: 266px; */
  
  /* Black */
      background: #212120;
  /* Grey */
      border: 0.5px solid #666666;
      padding-top: 15px;
      display: inline;
      color: white;
      text-decoration: none;
  ">View Cart</a></div>
                  </div>`;
                  newquizdesc +=`<span>Your Selections:</span> ${optionTagStr}`;
                  recomlist +=`<h2 class="product-count__text text-body">Recommended Paddles (4)</h2>`;
                  quizResult += `<div id="quiz-product-result">
                  <div class="facets facets-vertical-sort page-width quiz-product-main-title">
                      <h2>Select <span id="quiz-product-count">4</span> paddles to try during the Demo Program.</h2>
                  </div>
                  <div class="facets facets-vertical-sort page-width quiz-product-sub-title ">
                      
                      <p><span>Your Selections:</span> ${optionTagStr}</p>
                  </div>
                  <div class="facets-vertical page-width">
                      <div class="product-grid-container" id="ProductGridContainer">
                          <div class="collection">
                              <ul id="product-grid" data-id="template--16585824927960__1664276620af2d2432" class="grid product-grid grid--2-col-tablet-down grid--3-col-desktop">`;
                  $.each(prodIDTagArr, function(finalProdListIndex, finalProdList){
                    if(finalProdListIndex>3){
                      return false;
                    }
                    let finalProdId = finalProdList.prod_id;
                    let finalProdtags = finalProdList.tags;
                    let finalbody_html = finalProdList.body_html;
                    prodMetaId.push(finalProdId);
                    let finalProdTitle = finalProdList.title;
                    let finalProdImg = finalProdList.img;
                    let finalProdUrl = window.Shopify.routes.root+'products/'+finalProdList.handle;
                    //let finalProdBodyHtml = finalProdList.body_html;
                    
                    //console.log(finalProdListIndex,' --- ',finalProdList.prod_id,' ',window.Shopify.routes.root,' finalProdUrl ',finalProdUrl);
                    prodlist += `<li class="grid__item" data-prod-id="${finalProdId}">
                        <div class="card-wrapper underline-links-hover">
                            <div class="card card--standard card--media" style="--ratio-percent: 120.0%;">
                                <div class="card__inner color-background-1 gradient ratio" style="--ratio-percent: 120.0%;">
                                    <div class="quick-add top-left">
  
                                        <button id="quick-add-template-${finalProdId}" data-id="${finalProdId}" type="button" name="add" data-title="Add to Demo List" class="button button--full-width button--secondary demo-pro-btn variant-popup-btn" cart_added="false" aria-haspopup="dialog" data-hand-url="${finalProdUrl}">
  
                                            <span>
                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.601562 9.89863C0.601562 9.56629 0.857492 9.29688 1.1732 9.29688H9.17609C9.49179 9.29688 9.74772 9.56629 9.74772 9.89863C9.74772 10.231 9.49179 10.5004 9.17609 10.5004H1.1732C0.857492 10.5004 0.601562 10.231 0.601562 9.89863Z" fill="#212120"></path>
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.57831 10.5488C9.24598 10.5488 8.97656 10.2794 8.97656 9.94708V1.52256C8.97656 1.19022 9.24598 0.920808 9.57831 0.920808C9.91065 0.920808 10.1801 1.19022 10.1801 1.52256V9.94708C10.1801 10.2794 9.91065 10.5488 9.57831 10.5488Z" fill="#212120"></path>
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.58222 18.7178C9.24988 18.7178 8.98047 18.4484 8.98047 18.116V9.69151C8.98047 9.35917 9.24988 9.08975 9.58222 9.08975C9.91456 9.08975 10.184 9.35917 10.184 9.69151V18.116C10.184 18.4484 9.91456 18.7178 9.58222 18.7178Z" fill="#212120"></path>
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.7383 9.8996C10.7383 9.56726 11.0342 9.29785 11.3992 9.29785H18.5373C18.9023 9.29785 19.1982 9.56726 19.1982 9.8996C19.1982 10.2319 18.9023 10.5014 18.5373 10.5014H11.3992C11.0342 10.5014 10.7383 10.2319 10.7383 9.8996Z" fill="#212120"></path>
                                                </svg>
                                            </span>
                                            <div class="loading-overlay__spinner hidden">
                                                <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                                                </svg>
                                            </div>
                                        </button>
                                        <div class="plus-cart-icon-msg" style="display: none;"><span class="added-item-msg"><span class="lineitem-data"><span class="lineitem-title">Product</span> is in your demo list. (<span class="plus-icon-cart-count"></span> of 4)</span></span></div>
                                    </div>
                                    <div class="card__media click_demo_popup">
                                        <div class="media media--transparent media--hover-effect">
                                            <img src="${finalProdImg}" alt="DEMO GX6 CONTROL - GREEN - 7.8OZ" class="motion-reduce" width="1000" height="1200">
                                        </div>
                                    </div>
                                    <div class="card__content">
                                        <div class="card__information">
                                            <h3 class="card__heading" data-title="${finalProdTitle}">
                                            <a href="${finalProdUrl}" class="full-unstyled-link">
                                            ${finalProdTitle}
                                            </a>
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                                <div class="card__content">
                                    <div class="card__information">
                                      
                                        <h3 class="card__heading  h5 main_title" id="title-template--16585824927960__1664276620af2d2432-7756962267352" data-title="${finalProdTitle}">
                                            <a href="${finalProdUrl}" class="full-unstyled-link">
                                            ${finalProdTitle}
                                            </a>
                                        </h3>
                                        <span class="tag-show" id="metatag-${finalProdId}"></span>
                                      
                                        <div class="card-information demo_feataure" id="meta-${finalProdId}"><span class="caption-large light"></span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>`;
                  })
                  quizResult += `</ul>
                              </div>
                          </div>
                      </div>
                  </div>`;                  
                } else {
                  prodlist = '<p>No product found.</p>'
                }
                ////////////////////////
                var currentMetaId = 0;
                if(prodMetaId){
                  getProdMeta(currentMetaId);
                }
                
                function getProdMeta(currentMetaId) {
                  $.ajax({
                    url: baseApiUrl+'/meta-fields/'+prodMetaId[currentMetaId],
                    type: 'GET',
                    beforeSend: function() {
                  
                    },
                    /*complete: function() {
                      currentMetaId++;
                      if (currentMetaId < prodMetaId.length) {
                        getProdMeta();
                      }
                    },*/
                    success: function(result) {
                      //console.log("meta result ",result.data);
                      //console.log("meta array");
                      var new_arr  = result.data;
                     
  
                      /*for (index in new_arr) {
                          console.log("meta result ",new_arr[index].key);
                          if(new_arr[index].key == ''){
                            $('.quiz-product-section #meta-'+prodMetaId[currentMetaId]).html(result.data.metafields[0].value);
                          }else if(new_arr[index].key == ''){
  
                          }
                        }*/
  
  
                      //alert(result.data.metafields[0].value);
                      
                       $('.quiz-product-section #meta-'+prodMetaId[currentMetaId]).html(result.data.metafields[0].value);
                      currentMetaId++;
                      if (currentMetaId < prodMetaId.length) {
                        getProdMeta();
                      }
                    }
                  });
                }
                
  
                /////////////////
  
                $('.quiz-close').trigger('click');
               // $('.quiz-product-section').html(quizResult);
              // alert(prodlist);
               if(prodlist == ''){
                //alert("test");
                 location.href = window.Shopify.routes.root+'collections/demo-program-via-api?sort_by=best-selling&';
               
                 return false;
               }
               $("h2.product-count__text.text-body.asdasd").text("All Other Paddles");
               $('div#recommend_demo').html('<facet-filters-form class="facets facets-vertical-sort page-width small-hide no-js-hidden"></facet-filters-form><h2 class="product-count__text text-body asdasd"></h2><p style="text-align: left;padding-top: 12px;padding-left: 0px;padding-bottom: 10px;" class="container demo_api_desc"></p><ul id="product-grid" data-id="template--16585824927960__1664276620af2d2432" class="grid product-grid grid--2-col-tablet-down grid--3-col-desktop">'+prodlist+'</ul>');
               
               $('div#ProductGridContainer ul#product-grid li').each(function(){
                $(this).css("display","block");
                  var prod_title = $(this).find("h3.card__heading.h5.main_title").attr("data-title");
                 var remove_prod = false;
                  $('div#recommend_demo ul#product-grid li').each(function(){
  
                    var recomd_title = $(this).find("h3.card__heading.h5.main_title").attr("data-title");
                    //alert(recomd_title);
                   // console.log(recomd_title+'-'+prod_title);   
                      if(recomd_title == prod_title){
                         remove_prod = true;
                       // alert(remove_prod);
                      }
                    });
                  if(remove_prod){
                    $(this).css("display","none");
                  }
                });
  
               $("div#recommend_demo h2.product-count__text.text-body.asdasd").html(recomlist);
  
               //$(".pagination-wrapper").css("display","none");
               $("div#recommend_demo .demo_api_desc").html(newquizdesc);
               //$(".facets.facets-vertical-sort.page-width.quiz-product-main-title").remove();
             $("div#recommend_demo facet-filters-form.facets.facets-vertical-sort.page-width.small-hide.no-js-hidden").prepend(newquiztitle);
               
              // $(".filter-des").css("display","none");
              //  $(".facet-filters.sorting.caption").css("display","none");
  
                var cartlegth  = $ ("div#recommend_demo ul#product-grid").children().length;
  
                $("div#recommend_demo h2.product-count__text.text-body.asdasd").html('<h2 class="product-count__text text-body">Recommended Paddles ('+cartlegth+')</h2>');
  
  
                $('.cart-drawer-min .cdmset').each(function(index,item){
  
                  var qty_tot
                    let dataitem = $(this).attr('data');
                    if(dataitem){
                      // if(var_tit.match("^DEMO") && (dataitem == 'DEMO'|| dataitem == 'demo')){
                      if((dataitem == 'DEMO'|| dataitem == 'demo'|| dataitem == 'Demo')){
                       // console.log($(this).find('.cdmtitle').text(), $(this).find('quantity-input').find('input').val());
                        qty_tot = qty_tot + parseInt($(this).find('quantity-input').find('input').val());
                         // console.log($('#product-grid li .card > .card__content .card__heading a:contains("'+$(this).find('.cdmtitle').text()+'")').parents('.card__content').siblings('.card__inner').find('.quick-add'));
                          $('#product-grid li .card > .card__content .card__heading a:contains("'+$(this).find('.cdmtitle').text()+'")').parents('.card__content').siblings('.card__inner').find('.quick-add').find('.plus-icon-cart-count').text($(this).find('quantity-input').find('input').val());
                          $('#product-grid li .card > .card__content .card__heading a:contains("'+$(this).find('.cdmtitle').text()+'")').parents('.card__content').siblings('.card__inner').find('.quick-add').find('.plus-cart-icon-msg').show()
                      }$('#product-grid li .card > .card__content .card__heading a:contains("'+$(this).find('.cdmtitle').text()+'")').parents('.card__content').siblings('.card__inner').find('.quick-add').find('.plus-cart-icon-msg').attr("addedcart","true");
                    }
                  });
                
                /*-- End of Display product based on quiz --*/
            },
            error: function (jqXhr, textStatus, errorMessage) {
                    //$('p').append('Error' + errorMessage);
                    //console.log('errorMessage ',errorMessage);
                    $('body').css('opacity','unset');
            }
        });
    });
  var url_string = window.location.href; 
 // console.log('url ',url_string);
  var newUrl = new URL(url_string);
  var bestSelling = newUrl.searchParams.get("sort_by");
  if(bestSelling == 'best-selling'){
      $('html, body').animate({
        scrollTop: $(".quiz-product-section").offset().top
    }, 500);
  }
    $('body').on('click', '.pquizb-btnset-2, .pquizb-btnset-2-2, .pquizb-btnset-3-2, .pquizb-btnset-4-2, .pquizb-btnset-5-2', function(){
      //$('#SortBy').val('best-selling').trigger('change');
      //$('.quiz-close').trigger('click');
      var step_next = $(this).attr("step_next");
       $(this).closest(".popup-quiz-set").find(".pqmd-btn.active").removeClass("active");
      $(this).closest(".quiz_step").css("display","none");
      if(!$(this).closest(".pquizb-bothbtn").find(".btn-inf").hasClass("disable_continue")){
          $(this).closest(".pquizb-bothbtn").find(".btn-inf").addClass("disable_continue");
      }
      
      var new_step = ".popup-quiz-"+step_next+".quiz_step";
      //alert(new_step);
  
      $(new_step).css("display","block");
   //   location.href = window.Shopify.routes.root+'collections/demo-program-via-api?sort_by=best-selling&';
    //   $('html, body').animate({
    //     scrollTop: $(".quiz-product-section").offset().top
    // }, 1000);
    });
  
    //Back Button
    $('body').on('click', '.popup-back', function(){
        if($(this).hasClass('bk-2')){
            RemoveOptionNode(1);
            //console.log('back ',quizOptionArr);
        } else if($(this).hasClass('bk-3')){
            RemoveOptionNode(2);
            //console.log('back ',quizOptionArr);
        } else if($(this).hasClass('bk-4')){
            RemoveOptionNode(3);
            //console.log('back ',quizOptionArr);
        } else if($(this).hasClass('bk-5')){
            RemoveOptionNode(4);
            //console.log('back ',quizOptionArr);
        } else if($(this).hasClass('bk-6')){
            RemoveOptionNode(5);
            //console.log('back ',quizOptionArr);
        }
    });
    function RemoveOptionNode(id){
        quizOptionArr.forEach(function(e, index){
        if(id == e.id){
            quizOptionArr.splice(index, 1);
        }
      });
    }
    /*-- variant display and add-to-cart --*/
    $('body').on('click','.shopify-section .variant-popup-btn',function(){
      setTimeout(function () {
        $('body').addClass('demorecomend-pop');
        $("body").addClass("active-popup");
      }, 500);
      /*-- meta content get --*/
      let tempProdId = $(this).data('id');
      let metaContent =  $(this).parents('.card--standard').find('#meta-'+tempProdId).html();
      /*console.log('metaContent ',metaContent);*/
      /*-- EOF meta content get --*/
      $(".quiz-main.product-variant").css("display","block");
      let crntSlug = $(this).data('hand-url');
     // alert($(this).attr("handle"));
      var carnt_url = crntSlug.split("/");
     // alert(window.Shopify.routes.root);
     // return false;
      if (crntSlug.charAt(0) == "/") crntSlug = crntSlug.substr(1);
      var arrurl = crntSlug.split("?");
      //alert(window.Shopify.routes.root + arrurl[0]+'.js');
      //console.log('crntSlug ',crntSlug);
      jQuery.getJSON(window.Shopify.routes.root + arrurl[0]+'.js', function(product) {
        let prodVariant = product.variants;
        let variantDropDown = '';
        let variantArr = [];
        if(prodVariant){
          /*console.log('prodVariant ',prodVariant);*/
          if(prodVariant.length === 1){
            variantArr.push(prodVariant[0].id);
            if(prodVariant[0].available){
              allDisabled = 1;
              variantDropDown = `<input id="selectedSingleVariant" type="text" data-available="${prodVariant[0].available}" data-var-id="${prodVariant[0].id}" value="${product.title}" readonly />`;
            } else{
              variantDropDown = `<input id="selectedSingleVariant" disabled type="text" data-available="${prodVariant[0].available}" data-var-id="${prodVariant[0].id}" value="${product.title} (Out of stock)" readonly />`;
            }
          } else{
            variantDropDown = '<select id="variant-dropdown">';
            $.each(prodVariant, function(prodVariantIndex, prodVariantVal){
              /*console.log('prodVariantVal ',prodVariantVal);*/
              variantArr.push(prodVariantVal.id);
              let variantTitle = prodVariantVal.title;
              if(variantTitle == 'Default Title'){
                variantTitle = product.title;
              }
              if(prodVariantVal.available){
                allDisabled = 1;
                variantDropDown += '<option data-available="'+prodVariantVal.available+'" data-var-id="'+prodVariantVal.id+'">'+variantTitle+'</option>';
              } else{
                variantDropDown += '<option disabled data-available="'+prodVariantVal.available+'" data-var-id="'+prodVariantVal.id+'">'+variantTitle+' (Out of stock)</option>';
              }
            });
            variantDropDown += '</select>';
          }
        }
        let proddesc = product.description;
  
        let nrwproddesc = proddesc.substring(0,150);
        if(proddesc.length > 150){
          nrwproddesc += '...<span class="show_desc">Show More</span><span class="hide_desc">Show less</span>';
        }
        proddesc = '<div class="full_Desc">'+proddesc+'<span class="trans_div"></span></div>';
        
        let variantContent = `<div class="left-content">
          <img style="width:100px;height: auto;" src='${product.featured_image}' />
        </div>
        <div class="right-content">
          <div class="title">${product.title}</div>
          <div class="description" style="display:none;">${nrwproddesc}</div>
          <div class="description full_content">${proddesc}</div>
          <div class="variant">
            <span>Paddle Options:</span>
            ${variantDropDown}
          </div>
          <div class="size-guide" style="display: none;"><a href="javascript:void(0);">Size Guide</a></div>
          <div class="cart-btn">
                <a class="demo-add-cart-btn" href="javascript:void(0);" recommended="true" addedcart="false">Add to Demo Cart</a>
            </div>
        </div>
        `;
       // alert(variantContent);
  
        $('.prod-inner-content').html(variantContent);
        $.getJSON("/cart.js", function(cartRes){
          /*console.log('cartRes ',cartRes,' variantArr ',variantArr);*/
          if(cartRes.item_count > 0){
            let itemChk = cartRes.items;
            let itemMatchArr = [];
            for(let lineItems of itemChk){
              if(variantArr.includes(lineItems.variant_id)){
                itemMatchArr.push(lineItems.variant_id);
              }
            }
            /*console.log('itemMatchArr ',itemMatchArr);*/
            if(itemMatchArr.length > 0){
              for(let itemMatchArrs of itemMatchArr){
                if(($(".quiz-main.product-variant .variant #selectedSingleVariant")) && ($(".quiz-main.product-variant .variant #selectedSingleVariant").data('var-id') == itemMatchArrs)){
                  $(".quiz-main.product-variant .variant #selectedSingleVariant").addClass('alreadyExist').prop('disabled', true);
                } else if($(".quiz-main.product-variant .variant #variant-dropdown")){
                  $(".quiz-main.product-variant .variant #variant-dropdown option").each(function(i, obj){
                    if($(this).data('var-id') == itemMatchArrs){
                      $(this).addClass('alreadyExist').prop('disabled', true);
                    }
                  });
                }
              }
            }
            /*-- Disable add-to-cart button --*/
            let cartBtnDisable = 0;
            if($(".quiz-main.product-variant .variant #selectedSingleVariant").length){
                if($(".quiz-main.product-variant .variant #selectedSingleVariant").is(':disabled')){ } else{
                    cartBtnDisable = 1;
                }
            } else if($(".quiz-main.product-variant .variant #variant-dropdown").length){
                $(".quiz-main.product-variant .variant #variant-dropdown option").each(function(i, obj){
                    if($(this).is(':disabled')){console.log('got disabled');} else{
                        cartBtnDisable = 1;
                    }
                });
            }
            if(cartBtnDisable === 0){
                $('.prod-inner-content .cart-btn').addClass('disabled_btn');
            }
            /*-- EOF Disable add-to-cart button --*/
          }
        });
      });
    });
    $('body').on('click','.shopify-section .prod-variant-popup-close',function(){
      $('body').removeClass('demoapiadd-pop');
      $('body').removeClass('demorecomend-pop');
      $('body').removeClass('active-popup');
      $(".quiz-main.product-variant").css("display","none");
    });
    $('body').on('click','.shopify-section .demo-add-cart-btn', async function(e){
      $('.loader-sec').show();
      let getSelectedVariant = $(".quiz-main.product-variant select#variant-dropdown option").filter(":selected");
      let varAvailStatus = selectedVariantId = selectedVariantExist = '';
      if(getSelectedVariant.length >0){
        varAvailStatus = getSelectedVariant.data('available');
        selectedVariantId = getSelectedVariant.data('var-id');
        selectedVariantExist = getSelectedVariant.hasClass('alreadyExist');
      } else{
        varAvailStatus = $(".quiz-main.product-variant input#selectedSingleVariant").data('available');
        selectedVariantId = $(".quiz-main.product-variant input#selectedSingleVariant").data('var-id');
        selectedVariantExist = $(".quiz-main.product-variant input#selectedSingleVariant").hasClass('alreadyExist');
      }
      /*-- Show validation based on stock --*/
      if(!varAvailStatus){
        if($('.quiz-main.product-variant .var-stock-err').length ===0){
          $('.quiz-main.product-variant .demo-add-cart-btn').after(`<p class="var-stock-err">Out of stock</p>`); 
        } else{
          $('.quiz-main.product-variant .var-stock-err').text('Out of stock').css('display','block');
        }
        $('.loader-sec').hide();
        return false;
      } else{
        $('.quiz-main.product-variant .var-stock-err').css('display','none');
      }
      /*-- EOF show validation based on stock --*/
      /*-- Hide validation if already in cart --*/
      if(selectedVariantExist){
        $('.loader-sec').hide();
        return false;
      } else{
        $('.quiz-main.product-variant .var-stock-err').css('display','none');
      }
      /*-- EOF Hide validation if already in cart --*/
      /*-- Show validation if variant already exist in cart --*/
      let cartItemCount = 0;
      try{
        let cartFetch = await cartFetchAPI();
        if((cartFetch.items) && ((cartFetch.items.length>0))){
            cartItemCount = cartFetch.item_count;
          for(let ic=0; ic < cartFetch.items.length; ic++){
            if(cartFetch.items[ic].variant_id == selectedVariantId){
              if(cartFetch.items[ic].quantity > 1){
                let lineItemChange = await cartChangeAPIDynamic(cartFetch.items[ic].key,1); //set quantity to one
              }
              if($('.quiz-main.product-variant .var-stock-err').length ===0){
                $('.quiz-main.product-variant .demo-add-cart-btn').after(`<p class="var-stock-err">Already exist in cart</p>`); 
              } else{
                $('.quiz-main.product-variant .var-stock-err').text('Already exist in cart').css('display','block');
              }
              $('.loader-sec').hide();
              return false;
            }
          }
        }
      } catch(cartFetchErr){
        //console.log('cartFetchErr ',cartFetchErr);
      }
      /*-- EOF show validation if variant already exist in cart --*/
      var cart_count = 0;
      var newcartquiztitle  =` <h2>Nice! Let's wrap this up.</h2>
        <div style="display: flex;margin-bottom: 35px;text-align: center;display: inline-grid;" class="view_Cart_demoapi">
        <a href="/cart" style="width: 198px;height: 52px;background: #212120;border: 0.5px solid #666666;padding-top: 15px;display: inline;color: white;text-decoration: none;">View Cart</a></div>`;
      var cartlegth  = $ ("ul#product-grid").children().length;
      e.preventDefault();
      
      
      var qty_tot = 0;
      let demoFound = false;
       $('.cart-drawer-min .cdmset').each(function(index,item){
        let dataitem = $(this).attr('data');
        if(dataitem){
          if((dataitem == 'DEMO'|| dataitem == 'demo'|| dataitem == 'Demo')){
            demoFound = true;
            // console.log($(this).find('quantity-input').find('input').val())
            qty_tot = qty_tot + parseInt($(this).find('quantity-input').find('input').val());
          }
        }
      });
      // console.log('qty_tot', qty_tot)
      // console.log('selectedVariantId ',selectedVariantId);
      //if ((!demoFound) && ($('.cart-count-bubble [data-cart-count]').text() != 0)) {
      if ((!demoFound) && (cartItemCount !=0)) {
        setTimeout(function(){
            $('body').addClass('demoapiadd-pop');
            $(".cdel").addClass("show-cdel");
            $("body").addClass("active-popup");
            $('.loader-sec').hide();
        }, 500);
        //console.log('already exist');
        return false;
      } else{
        if(qty_tot >= 4){
          $('.loader-sec').hide();
          $(".cdelmax").addClass("show-cdel-max");
          $(".cdelmax .max-info").show();
          $(".cdelmax .demo-program").hide();
          $("body").addClass("active-popup");
          $(".facets.facets-vertical-sort.page-width.quiz-product-main-title").html(newcartquiztitle);
        } else{
          $('.loader-sec').show();
          var newcart = $(this);
          data = {
              "id": selectedVariantId,
              "quantity": 1
          }
          $.ajax({
            type: 'POST',
            url: window.Shopify.routes.root+'cart/add.js',
            dataType: 'json',
            data: data,
            success: function(){
              // console.log('suuceess');
              min_cart();
              setTimeout(function() {
                $('.loader-sec').hide();
                $('.cart-drawer').addClass("cart-dra-opp");
                $("body").addClass("active-popup");
                $("div#ProductGridContainer").addClass("open_new_demo");
              $("body").addClass("drawer_open");
    
                $.getJSON("/cart.js", function(cart) {
                $(".count-item-carts").text(cart.item_count);
                $(".cart-count-bubble").text(cart.item_count);
                if (cart.item_count > 0) {
                  $(".header__icon--cart .cart-count-bubble").removeClass('hide');
                } else {
                  $(".header__icon--cart .cart-count-bubble").addClass('hide');
                }
                });
                $(".popup-closes").click();
              // $("#quiz-product-count").text($("#quiz-product-count").text() - 1);
                $('.loader-sec').hide();
                
              //  alert(selectedVariantId);
    
                $('div#ProductGridContainer ul#product-grid li').each(function(index,item){
                // console.log("test");
                  var idvar = $(this).find('input[name="id"]').val();
                  if(idvar == selectedVariantId){
                  //  alert(idvar);
                    //$(this).css("display","none");
                  }
                });
    
              },2000);
            },
            // error: addToCartFail
          });
        }
      }
    });
    /*-- EOF variant display and add-to-cart --*/
    // $('body').on('click','.plus-cart-icon-msg', function(e){
    //   if(e.target !== e.currentTarget) return;
    //   console.log('plus-btns',e.target,' ', e.currentTarget);
    //   $(this).parents('.quick-add').find('.variant-popup-btn').trigger('click');
    // });
    /*-- Remove demo product from cart --*/
    // $('body').on('mouseenter','.quiz-product-section .plus-cart-icon-msg .lineitem-data, .quiz-product-section .plus-cart-icon-msg .added-item-msg', function(e){
    //   $(this).parents('.plus-cart-icon-msg').addClass('delete');
    // });
    // $('body').on('mouseleave','.quiz-product-section .plus-cart-icon-msg .lineitem-data, .quiz-product-section .plus-cart-icon-msg .added-item-msg', function(e){
    //   $(this).parents('.plus-cart-icon-msg').removeClass('delete');
    // });
    $('body').on('click','.plus-cart-icon-msg .lineitem-data', function(e){
      //console.log('child',e.target,' ', e.currentTarget, e.target.className);
      if((e.target.className.includes('lineitem-data')) || (e.target.className.includes('lineitem-title')) || (e.target.className.includes('plus-icon-cart-count'))){
        let key = $(this).data('key');
        //console.log($(this), 'key ',key);
        if(key){
          let varId = key.split(':')[0];
          //console.log('varId ',varId);
          if(varId){
            $('.loader-sec').show();
          data = {
            "id": varId,
            "quantity": 0

          }
          $.ajax({
                type: 'POST',
                url: window.Shopify.routes.root+'cart/change.js',
                dataType: 'json',
                data: data,
                success: function(){
                  min_cart();
                  setTimeout(function(){
                    $.getJSON("/cart.js", function(cart){
                      $(".count-item-carts").text(cart.item_count);
                      $(".cart-count-bubble").text(cart.item_count);
                      if (cart.item_count > 0){
                        $(".header__icon--cart .cart-count-bubble").removeClass('hide');
                      } else{
                        $(".header__icon--cart .cart-count-bubble").addClass('hide');
                      }
                    });
                    $(this).css('display','none');
                    $('.loader-sec').hide();
                  },2000);
                },
            });
          }

        }
      }
    });
    /*-- EOF Remove demo product from cart --*/
    /*-- Start of video popup toggle --*/
    $('body').on('click','.pop-quiz-mid-info .about-padd',function(){
      var videoUrl = $(this).data('video');
      //alert(videoUrl);

      $('.quiz-video-pop video source').attr("src",videoUrl);
      $('.quiz-video-pop video').remove();
      $('.video-sec-gel.pop-gel-vid.quiz-video-pop').css('display','block');
      $('.quiz-video-pop .video-sec-set').css('display','flex');
      
       $('.video-sec-video.pop-gel-set').css('display','block');
       $('.quiz-video-pop .video-sec-pop').append('<video muted="" playsinline="" autoplay="" loop="" id="newmyvideo" width="100%"><source src="'+videoUrl+'" type="video/mp4"></video>');
       $('.quiz-video-pop video').get(0).play();

       if($("body").hasClass("active-pop")){
          $("body").addClass("video_popup");
       }
      return false;
    });
    $('body').on('click','.quiz-video-pop .close-vid',function(){
      $('.quiz-video-pop').css('display','none');
    });
    /*-- End of video popup toggle --*/
    /*-- cart json API --*/
    async function cartFetchAPI(){
      let cartData = $.ajax({
        type: "GET",
        dataType: "json",
        url: window.Shopify.routes.root + "cart.js",
        cache: false,
      });
      return cartData;
    }
    /*-- EOF cart json API --*/
    /*-- lineItem quantity change API --*/
    async function cartChangeAPIDynamic(getItemKey, getQuant){
      var cartChngResult = $.ajax({
        type: "POST",
        url: window.Shopify.routes.root + "cart/change.js",
        dataType: "json",
        data: {
          'id': getItemKey,
          'quantity': getQuant,
        },
      });
      return cartChngResult;
    }
    /*-- EOF lineItem quantity change API --*/
  });
  /*-- EOF Popup quiz js --*/
jQuery(document).ready(function(){
  if($(".faq-popup").find(".faq-content-wrapper").length == 0){
    $("#faq-popup-se").prev("div").css("border-bottom","0.5px solid #666666");
    $("#faq-popup-se").remove();
}
});